/**
 * ManuscriptReviewReportApp_v2 Definition
 * App metadata for the Manuscript Review Report application
 */

import { AppDefinition } from '../../types/apps';

export const ManuscriptReviewReportAppDefinition: AppDefinition = {
  appId: 'manuscript-review-report',
  name: 'Manuscript Review Report',
  version: '1.0.0',
  description: 'View AI-generated beta-reader analysis reports for manuscripts, including aggregate scores and per-paragraph feedback.',
  longDescription: `A read-only report viewer for manuscript beta-reader reviews generated by AI analysis.

**Key Features:**
- **Aggregate Scores**: 9 dimensions rated 1–10 (pacing, engagement, characters, prose, plot, dialogue, world-building, emotional impact, overall)
- **Qualitative Summary**: Overall assessment, strengths, weaknesses, and prioritized revision recommendations
- **Per-Paragraph Analysis**: Individual paragraph scores, issue flags, emotional tone, and reviewer comments
- **Live Updates**: Auto-refreshes while the review is in progress
- **Smart Filters**: Filter paragraphs by flags, low scores, or view all`,
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Newspaper',
    phosphorWeight: 'duotone',
    color: '#9b59b6',
  },

  creator: {
    name: 'River',
    verified: true
  },

  categories: ['Writing', 'Analytics'],
  tags: ['manuscript', 'review', 'betareader', 'report', 'writing', 'analysis'],
  releaseDate: new Date().toISOString(),
  lastUpdated: new Date().toISOString(),

  entityTypes: ['ManuscriptReviewReport'],
  component: 'ManuscriptReviewReportApp_v2',
  requiresEntity: true,
  requiresProps: false,

  hotkeys: {},
  agenticToolIds: [],
  actions: {},
  experimental: true,
};

export default ManuscriptReviewReportAppDefinition;
